/*
 * @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @Deion: 
 * @Date: 2022-09-15 15:40:15
 * @LastEditors: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @LastEditTime: 2022-10-18 14:57:36
 * @FilePath: /ywx-open/vue/src/views/agent/serviceDetails/orderManage/logic.js
 */
import { bus } from '@/utils/bus';
import Doctor from './components/doctor.vue';
import Patient from './components/patient.vue';
import Bread from '@/components/bread/index'  // 引入面包屑组件

import Vue from 'vue';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

export default {
  components: {
    Doctor,
    Patient,
    Bread
  },
  data() {
    return {
      activeName: 'doctor',
      drawer: false, //  帮助指引
      departOptions: [],
      clientId: this.$store.getters.currentClientId,
      justSZRZ: false
    };
  },
  created() {
    // this.getDepartList();
    
    if(VueCookies.get('justSZRZ')==='true') {
      this.justSZRZ = 'true'
    }
  },
  methods: {
    handleClick(tab) {
      console.log(tab)
      bus.$emit('tabChange')
      // switch (tab.index) {
      //   case '0':
      //     this.$refs.trusted.reset();
      //     break;
      //   case '1':
      //     this.$refs.preliminary.reset();
      //     break;
      //   default:
      // }
    },
    // async getDepartList() {
    //   await DepartmentList(this.clientId).then((result) => {
    //     this.departOptions = result.data.list;
    //   });
    // },
  },
};
